export class LoadDocsModel {
    dtpAppt: string
    message: string
    appt_resource_id: number
    appt_resource_code: string
    appt_resource_time_str: string
    bg: string
    appt_employee_no: number
    clinic_no: number

    constructor(
        dtpAppt: string,
        message: string,
        appt_resource_id: number,
        appt_resource_code: string,
        appt_resource_time_str: string,
        bg: string,
        appt_employee_no: number
    ) {
        this.dtpAppt = dtpAppt
        this.message = message
        this.appt_resource_id = appt_resource_id
        this.appt_resource_code = appt_resource_code
        this.appt_resource_time_str = appt_resource_time_str
        this.bg = bg
        this.appt_employee_no = appt_employee_no
    }
}